import { select } from "../utils/function";

const customInfo = select(".custom-info");

if (customInfo) {
  document.body.setAttribute("data-info", true);
}
